// extracted by mini-css-extract-plugin
export var addToCartButton = "_jd-b";
export var arrowButtonContainer = "_jd-9";
export var arrowButtonIcon = "_jd-a";
export var carouselArrowButton = "_jd-6";
export var carouselElementContainer = "_jd-1";
export var left = "_jd-7";
export var productDisplayCarouselContainer = "_jd-0";
export var productTileContainer = "_jd-2";
export var productTileImage = "_jd-4";
export var productTileImageContainer = "_jd-3";
export var productTileTitle = "_jd-5";
export var right = "_jd-8";
export var sliderOverflow = "_jd-c";